import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useAuth } from '@/context/AuthContext';
import { getEmployeeLeaveWallets } from '@/api/leaves';
import type {
  EmployeeLeavePolicyWalletItem,
  GetCompanyLeaveRequestByIdParams,
} from '@gokrew/models/leaves';
import { QueryKeys } from '@gokrew/models/constants/query-keys';

export const employeeLeaveWalletsKey = (
  params: GetCompanyLeaveRequestByIdParams
) => [QueryKeys.EmployeeLeaveWallets, params] as const;

export function useEmployeeLeaveWallets(
  params: GetCompanyLeaveRequestByIdParams,
  options?: Omit<
    UseQueryOptions<EmployeeLeavePolicyWalletItem[]>,
    'queryKey' | 'queryFn'
  >
) {
  const { branchId: authBranchId } = useAuth();
  const effectiveBranchId = params.branchId ?? authBranchId;
  return useQuery<EmployeeLeavePolicyWalletItem[]>({
    queryKey: [QueryKeys.EmployeeLeaveWallets, params, effectiveBranchId],
    queryFn: () =>
      getEmployeeLeaveWallets({
        ...params,
        ...(effectiveBranchId ? { branchId: effectiveBranchId } : {}),
      }),
    ...options,
  });
}
